module.exports = __webpack_public_path__ + "media/mypage/images/icons/s_icon_map-9f8172f0e0bdca20dab93b3977475a63.png";